"use client";
import { jsxs as a, jsx as t } from "react/jsx-runtime";
import { useLocaleText as N, Grid as n, rem as e, Paragraph as o, Heading as T, Group as C, Icon as P, Link as S } from "@ingeniorforeningen/figurine-core";
import { forwardRef as E } from "react";
import { formatTime as x } from "../SingleTrackProgram.helpers.js";
import j from "./SingleTrackProgramProgramContributor.js";
import '../../../../assets/SingleTrackProgramEntry.css';const w = "_root_r4eg4_2", I = "_metaColumn_r4eg4_22", L = "_type_r4eg4_30", $ = "_language_r4eg4_35", v = "_title_r4eg4_41", B = "_contributor_r4eg4_45", G = "_remark_r4eg4_55", r = {
  root: w,
  metaColumn: I,
  type: L,
  language: $,
  title: v,
  contributor: B,
  remark: G
}, g = E((u, _) => {
  const {
    startTime: d,
    endTime: s = "",
    title: h,
    description: l,
    link: b,
    contributors: i = [],
    languageAnnotation: c,
    online: f,
    ...y
  } = u, k = N(), m = i[0]?.link?.href || b?.href || void 0, p = /* @__PURE__ */ a(n, { ref: _, ...y, container: !0, columns: 12, children: [
    /* @__PURE__ */ a(
      n,
      {
        item: !0,
        span: 4,
        xs: 4,
        sm: 2,
        pt: { base: e("24px"), xs: e("32px") },
        pb: { base: e("24px"), xs: e("32px") },
        pl: { base: e("24px"), xs: e("16px") },
        pr: { base: 0, xs: e("16px") },
        children: [
          /* @__PURE__ */ a("div", { className: r.metaColumn, children: [
            /* @__PURE__ */ t(o, { text: `${x(d)}${s ? " -" : ""}` }),
            !!s && /* @__PURE__ */ t(o, { text: `${x(s || /* @__PURE__ */ new Date())}` })
          ] }),
          f && /* @__PURE__ */ t(o, { text: k.online, className: r.type }),
          c && /* @__PURE__ */ t(o, { text: c, className: r.language })
        ]
      }
    ),
    /* @__PURE__ */ a(
      n,
      {
        item: !0,
        span: 6,
        xs: 6,
        sm: 8,
        pt: { base: e("24px"), xs: e("32px") },
        pb: { base: e("24px"), xs: e("32px") },
        pr: { base: 0, xs: e("32px") },
        maw: { base: e("189px"), xs: "none" },
        children: [
          /* @__PURE__ */ t(T, { type: "h3", text: h, className: r.title }),
          !!i.length && /* @__PURE__ */ t(C, { my: 0, className: r.contributor, children: /* @__PURE__ */ t(j, { contributors: i }) }),
          l && /* @__PURE__ */ t(o, { text: l, className: r.remark })
        ]
      }
    ),
    /* @__PURE__ */ t(n, { item: !0, span: 2, xs: 2, sm: 2, alignItems: "center", justifyItems: "end", pr: e("16px"), children: m && /* @__PURE__ */ t(P, { name: "ChevronRight" }) })
  ] });
  return m ? /* @__PURE__ */ t(n, { item: !0, className: r.root, children: /* @__PURE__ */ t(S, { href: m.toString(), children: p }) }) : /* @__PURE__ */ t(n, { item: !0, className: r.root, children: p });
});
g.displayName = "SingleTrackProgramEntry";
const z = g;
export {
  g as _SingleTrackProgramEntry,
  z as default
};
